import React, { useEffect, useRef, useState } from "react";
import { cellWidth } from "../../../core/methods/tableCellWidth";
import {
  parseDate,
  safeLocaleCompare,
} from "../../../core/methods/sorterMethods";
import { ColumnsType } from "antd/es/table";
import Datatable from "../../../core/common/dataTable";
import { PageBreadcrumb } from "../../../core/common/BreadCrumbForm";
import { all_routes } from "../../router/all_routes";
import { formatDate } from "../../../core/common/TabelValue";
import {
  SearchFilterErrors,
  SearchFilterRef,
  SearchPayload,
} from "../../../core/common/ManagerSingleSearchFilter/types";
import useApi from "../../../core/customhook/useApi";
import SearchFilter from "../../../core/common/ManagerSingleSearchFilter/SearchFilter";
import { useLocation } from "react-router";
import Swal from "sweetalert2";
import UserDetailsSection from "./UserDetailsSection";
import Loading from "../../../core/common/custom-loading/Loading";
import { getSearchableHeader } from "../../../core/utils/getSearchableHeader";
import { exportAntdTableToExcel } from "../../../core/utils/exportExcel";
import { filterByColumnSearch } from "../../admin/utils/filterByColumnSearch";

// breadcrumb data
const breadcrumbItem = [
  { label: "Manage Verifier" },
  { label: "Manage Verifier Cases" },
];

export interface PaginationType {
  current: number;
  pageSize: number;
  total: number;
}

const ManageVerifierCases = () => {
  const location = useLocation();
  const filterRef = useRef<SearchFilterRef>(null);
  const [errors, setErrors] = useState<SearchFilterErrors>({});
  const [showCasesModal, setShowCasesModal] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const initialSearchData: SearchPayload = {
    org_ids: [],
    project_ids: [],
    location_name: [],
    program_ids: [],
    department_ids: [],
  };

  const [allItemList, setAllItemList] = useState<any[]>([]);

  const [pagination, setPagination] = useState<PaginationType>({
    current: 1,
    pageSize: 1000,
    total: 0,
  });
  const [searchData, setSearchData] =
    useState<SearchPayload>(initialSearchData);
  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});

  type InviteItem = any;
  // const filteredData = (Array.isArray(allItemList) ? allItemList : []).filter(
  //   (item: InviteItem) => {
  //     return Object.entries(inventoryColumnSearch).every(([key, value]) => {
  //       if (!value) return true;

  //       return String(item[key as keyof InviteItem] ?? "")
  //         .toLowerCase()
  //         .includes(value.toLowerCase());
  //     });
  //   },
  // );

  const filteredData = filterByColumnSearch(
    Array.isArray(allItemList) ? allItemList : [],
    inventoryColumnSearch,
  );

  const verifier = location.state?.verifier;
  console.log("navigated verifier:", verifier);

  const searchCaseAPI = useApi<any>("/api/v1/agency/manager-assign-project", {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const manageVerifierCaseAPI = useApi<any>(
    "/api/v1/agency/agency-manager-verifyer-cases",
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const deleteVerifierAPI = useApi<any>(
    "/api/v1/agency/agency-member-case-map",
    {
      method: "DELETE",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const assignCasesApi = useApi<any>("/api/v1/agency/agency-member-case-map", {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  // handleTableChange
  const handleTableChange = (pgConfig: any) => {
    setPagination((prev) => ({
      ...prev,
      current: pgConfig.current,
      pageSize: pgConfig.pageSize,
    }));
  };

  const fetchData = async () => {
    try {
      const res = await manageVerifierCaseAPI.callApi({
        page: pagination.current,
        limit: pagination.pageSize,
        member_id: verifier?.member_id,
      });

      if (!res?.success) {
        setAllItemList([]);
        return;
      }

      setAllItemList(Array.isArray(res?.data?.rows) ? res.data.rows : []);
      setPagination((prev) => ({
        ...prev,
        current: res.data.pagination.page,
        pageSize: res.data.pagination.limit,
        total: res.data.pagination.totalRecords,
      }));
    } catch (error) {
      console.error(error);
      setAllItemList([]);
    }
  };

  useEffect(() => {
    if (!verifier?.member_id) return;
    fetchData();
  }, [verifier?.member_id, pagination.current, pagination.pageSize]);

  const validateFilters = (): boolean => {
    if (searchData.org_ids.length === 0) {
      setErrors({ org_ids: "Organization is required" });
      filterRef.current?.focusField("org_id");
      return false;
    }

    if (searchData.project_ids.length === 0) {
      setErrors({ project_ids: "Account is required" });
      filterRef.current?.focusField("project_id");
      return false;
    }

    setErrors({});
    return true;
  };

  const handleSearch = async () => {
    if (!validateFilters()) return;

    try {
      const res = await searchCaseAPI.callApi(searchData);

      if (!res?.success) {
        setTableData([]);
        return;
      }

      setTableData(
  Array.isArray(res?.data)
    ? res.data
    : Array.isArray(res?.data?.rows)
      ? res.data.rows
      : []
);
      setSelectedRows([]);
      setShowCasesModal(true);
    } catch (err) {
      console.error(err);
      setTableData([]);
      setShowCasesModal(false);
    }
  };
  const handleFilterChange = (data: SearchPayload) => {
    const orgChanged = data.org_ids.join(",") !== searchData.org_ids.join(",");

    setSearchData(data);
    setErrors((prev) => ({
      org_ids: data.org_ids.length > 0 ? undefined : prev.org_ids,
      project_ids:
        data.project_ids.length > 0 || orgChanged
          ? undefined
          : prev.project_ids,
    }));
  };

  const handleClear = () => {
    filterRef.current?.clear();
    setErrors({});
    setShowCasesModal(false);
    setTableData([]);
    setSelectedRows([]);
  };
  const handleDelete = async (member_case_map_id: number) => {
    const result = await Swal.fire({
      title: "Delete Verifier?",
      text: "Are you sure you want to remove this assigned case?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      const res = await deleteVerifierAPI.callApi(
        {},
        `/api/v1/agency/agency-member-case-map/${member_case_map_id}`,
      );

      if (!res?.success) {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: res?.message || "Unable to delete record.",
          showConfirmButton: true,
        });
        return;
      }

      Swal.fire({
        icon: "success",
        title: "Deleted",
        text: "Case removed successfully.",
        timer: 1800,
        showConfirmButton: true,
      });

      fetchData();
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    }
  };

  // handleAddVerifier
  const handleAssignVerifier = async () => {
    if (selectedRows.length === 0) {
      await Swal.fire({
        icon: "warning",
        title: "No Case Selected",
        text: "Please select at least one case to assign.",
        confirmButtonText: "OK",
      });

      return;
    }

    const cases = tableData
      .filter((row) => selectedRows.includes(row.assignment_id))
      .map((row) => ({
        case_id: row.assignment_id,
        package_id: row.package_id,
        org_id: searchData.org_ids,
        project_id: searchData.project_ids,
        program_id: searchData.program_ids,
        department_id: searchData.department_ids,
      }));

    const payload = {
      member_id: verifier?.member_id,
      cases,
    };

    try {
      const res = await assignCasesApi.callApi(payload);

      if (!res?.success) {
        await Swal.fire({
          icon: "error",
          title: "Failed",
          text: res?.error || res?.message || "Something went wrong.",
          confirmButtonText: "OK",
        });

        return;
      }
      await Swal.fire({
        icon: "success",
        title: "Success",
        text: res?.message || "Case assign successfully.",
        timer: 1500,
        showConfirmButton: true,
      });
      fetchData();
      setShowCasesModal(false);
    } catch (error: any) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.error ||
          error?.message ||
          "Something went wrong.",
      });
    }
  };

  // ---- Columns ----
  const columns: ColumnsType<any> = [
    {
      title: "Sr. No.",
      key: "serial_number",
      dataIndex: "serial_number",
      onCell: () => cellWidth(100),
      align: "center",
    },
    {
      title: getSearchableHeader(
        "Applicant Name",
        "full_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "full_name",
      key: "full_name",
      onCell: () => cellWidth(200),
      sorter: (a, b) => safeLocaleCompare(a, b, "full_name"),
    },
    {
      title: getSearchableHeader(
        "Candidate ID",
        "hrms_id",
        setInventoryColumnSearch,
      ),
      dataIndex: "hrms_id",
      key: "hrms_id",
      onCell: () => cellWidth(160),
      sorter: (a, b) => safeLocaleCompare(a, b, "hrms_id"),
    },
    {
      title: getSearchableHeader(
        "Case SPOC",
        "case_spoc",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_spoc",
      key: "case_spoc",
      onCell: () => cellWidth(160),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_spoc"),
    },
    {
      title: getSearchableHeader(
        "Case Status",
        "overall_status",
        setInventoryColumnSearch,
      ),
      dataIndex: "overall_status",
      key: "overall_status",
      onCell: () => cellWidth(140),
      sorter: (a: any, b: any) =>
        (a.overall_status ?? "").localeCompare(b.overall_status ?? ""),
      render: (text: any, record: any) => {
        return (
          <span
            style={{
              backgroundColor: record?.overall_color_value || "#6c757d",
              color: "#fff",
              padding: "5px 10px",
              borderRadius: "4px",
              display: "inline-block",
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {text ?? "-"}
          </span>
        );
      },
    },
    {
      title: getSearchableHeader(
        "Project",
        "project_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "project_name",
      key: "project_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.project_name ?? "").localeCompare(b.project_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Program",
        "program_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "program_name",
      key: "program_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.program_name ?? "").localeCompare(b.program_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Department",
        "department_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "department_name",
      key: "department_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.department_name ?? "").localeCompare(b.department_name ?? ""),
    },
    {
      title: getSearchableHeader("Email", "email", setInventoryColumnSearch),
      dataIndex: "email",
      key: "email",
      onCell: () => cellWidth(250),
      sorter: (a, b) => safeLocaleCompare(a, b, "email"),
    },
    {
      title: getSearchableHeader(
        "Case Received Date",
        "case_received_date",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_received_date",
      key: "case_received_date",
      onCell: () => cellWidth(200),
      render: (value: string) => formatDate(value),
      sorter: (a, b) =>
        parseDate(a.case_received_date).getTime() -
        parseDate(b.case_received_date).getTime(),
    },
    {
      title: getSearchableHeader(
        "Due Date",
        "due_date",
        setInventoryColumnSearch,
      ),
      dataIndex: "due_date",
      key: "due_date",
      onCell: () => cellWidth(180),
      render: (value: string) => formatDate(value),
      sorter: (a, b) =>
        parseDate(a.due_date).getTime() - parseDate(b.due_date).getTime(),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: 100,
      render: (_: any, record: any) => (
        <button
          type="button"
          className="btn btn-sm btn-outline-danger"
          onClick={() => handleDelete(record.member_case_map_id)}
          title="Delete"
        >
          <i className="ti ti-trash"></i>
        </button>
      ),
    },
  ];

  const columns_cases: ColumnsType<any> = [
    {
      title: "Sr. No.",
      key: "serial_number",
      dataIndex: "serial_number",
      onCell: () => cellWidth(100),
      align: "center",
    },
    {
      title: getSearchableHeader(
        "Applicant Name",
        "applicant_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "applicant_name",
      key: "applicant_name",
      onCell: () => cellWidth(200),
      sorter: (a, b) => safeLocaleCompare(a, b, "applicant_name"),
    },
    {
      title: getSearchableHeader(
        "Case ID",
        "case_id",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_id",
      key: "case_id",
      onCell: () => cellWidth(190),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_id"),
    },
    {
      title: getSearchableHeader(
        "Case SPOC",
        "case_spoc",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_spoc",
      key: "case_spoc",
      onCell: () => cellWidth(150),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_spoc"),
    },
    {
      title: getSearchableHeader(
        "Case Status",
        "overall_status",
        setInventoryColumnSearch,
      ),
      dataIndex: "overall_status",
      key: "overall_status",
      onCell: () => cellWidth(140),
      sorter: (a: any, b: any) =>
        (a.overall_status ?? "").localeCompare(b.overall_status ?? ""),
      render: (text: any, record: any) => {
        return (
          <span
            style={{
              backgroundColor: record?.overall_color_value || "#6c757d",
              color: "#fff",
              padding: "5px 10px",
              borderRadius: "4px",
              display: "inline-block",
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {text ?? "-"}
          </span>
        );
      },
    },
    {
      title: getSearchableHeader(
        "Project",
        "project_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "project_name",
      key: "project_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.project_name ?? "").localeCompare(b.project_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Program",
        "program_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "program_name",
      key: "program_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.program_name ?? "").localeCompare(b.program_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Department",
        "department_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "department_name",
      key: "department_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.department_name ?? "").localeCompare(b.department_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Candidate ID",
        "hrms_id",
        setInventoryColumnSearch,
      ),
      dataIndex: "hrms_id",
      key: "hrms_id",
      onCell: () => cellWidth(150),
      sorter: (a, b) => safeLocaleCompare(a, b, "hrms_id"),
    },
    {
      title: getSearchableHeader(
        "Case Received",
        "case_received_date",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_received_date",
      key: "case_received_date",
      render: (value: string) => formatDate(value),
      onCell: () => cellWidth(150),
    },
    {
      title: getSearchableHeader(
        "Due Date",
        "due_date",
        setInventoryColumnSearch,
      ),
      dataIndex: "due_date",
      key: "due_date",
      render: (value: string) => formatDate(value),
      onCell: () => cellWidth(150),
    },
    {
      title: getSearchableHeader(
        "Total Checks",
        "total_checks",
        setInventoryColumnSearch,
      ),
      dataIndex: "total_checks",
      key: "total_checks",
      align: "center",
      width: 180,
    },
    {
      title: "Select",
      key: "select",
      width: 90,
      align: "center",
      render: (_: any, record: any) => (
        <input
          type="checkbox"
          className="form-check-input"
          style={{
            transform: "scale(1.35)",
            cursor: "pointer",
          }}
          checked={selectedRows.includes(record.assignment_id)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedRows((prev) => [...prev, record.assignment_id]);
            } else {
              setSelectedRows((prev) =>
                prev.filter((id) => id !== record.assignment_id),
              );
            }
          }}
        />
      ),
    },
  ];

  const handleDownloadExcel = () => {
    exportAntdTableToExcel({
      columns,
      dataSource: filteredData,
      fileName: "Manage_Verifier_Cases_Report",
      sheetName: "Manage Verifier Cases",
    });
  };

  const loading = manageVerifierCaseAPI.loading;

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* PageBreadcrumb */}
        <PageBreadcrumb
          title="Manage Verifier Cases"
          breadcrumbs={breadcrumbItem}
          showBackButton={true}
          backRoute={all_routes.manager_Verifier}
          // showExport={true}
        />
        {/* /PageBreadcrumb */}

        <UserDetailsSection userDetails={verifier} />

        <div className="card mb-4">
          <div className="card-body">
            <div className="mb-4">
              <div>
                <h5 className="mb-1 fw-bold">Search Filters</h5>
                <p className="text-muted mb-0 small">
                  Select the required filters to search cases.
                </p>
              </div>
            </div>

            <SearchFilter
              ref={filterRef}
              value={searchData}
              onChange={handleFilterChange}
              storageKey="addVerifier"
              errors={errors}
            />

            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                className="btn btn-primary px-4"
                onClick={handleSearch}
                disabled={searchCaseAPI.loading}
              >
                <i className="ti ti-search me-1"></i>

                {searchCaseAPI.loading ? "Searching..." : "Search"}
              </button>

              <button
                className="btn btn-outline-secondary px-4"
                onClick={handleClear}
              >
                <i className="ti ti-refresh me-1"></i>
                Clear Filter
              </button>
            </div>
          </div>
        </div>

        <div className="card mt-4">
          {manageVerifierCaseAPI.loading ? (
            <Loading />
          ) : (
            <>
              <div className="d-flex justify-content-end pe-2 py-2 pb-0">
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={handleDownloadExcel}
                  disabled={loading}
                >
                  <i className="ti ti-download" /> Export to Excel
                </button>
              </div>
              <Datatable
                columns={columns}
                dataSource={filteredData}
                rowKey="member_case_map_id"
                Selection={false}
                pagination={pagination}
                fixedHeader
                tableHeight={650}
                handleTableChange={handleTableChange}
                // loading={manageVerifierCaseAPI.loading}
              />
            </>
          )}
        </div>

        {/* cases modal */}
        {showCasesModal && (
          <>
            {/* Backdrop */}
            <div className="modal-backdrop fade show"></div>

            {/* Modal */}
            <div
              className="modal fade show d-block"
              tabIndex={-1}
              aria-modal="true"
              role="dialog"
            >
              <div
                className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl"
                // style={{
                //   maxWidth: "1450px",
                //   width: "95%",
                // }}
              >
                <div className="modal-content border-0 shadow-lg rounded-2">
                  {/* Header */}
                  <div className="modal-header bg-light border-bottom px-4 py-3">
                    <div>
                      <h4 className="fw-bold mb-1">Assign Cases</h4>

                      <small className="text-muted">
                        Select one or more cases and assign them to the
                        verifier.
                      </small>
                    </div>

                    <button
                      className="btn-close"
                      onClick={() => {
                        setShowCasesModal(false);
                        setSelectedRows([]);
                      }}
                    />
                  </div>

                  {/* Body */}
                  <div className="modal-body p-4">
                    {/* Top Info */}
                    <div className="d-flex justify-content-end align-items-center flex-wrap gap-3 mb-3">
                      <div className="d-flex gap-2">
                        <span className="badge bg-primary px-3 py-2">
                          Total Cases : {tableData.length}
                        </span>

                        <span className="badge bg-success px-3 py-2">
                          Selected : {selectedRows.length}
                        </span>
                      </div>
                    </div>

                    {/* Table */}
                    <div className="card">
                      <div className="card-body p-0">
                        <Datatable
                          rowKey="assignment_id"
                          dataSource={tableData}
                          columns={columns_cases}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="modal-footer bg-light border-top gap-3">
                    <button
                      className="btn btn-primary px-4"
                      onClick={handleAssignVerifier}
                    >
                      <i className="ti ti-check me-2"></i>
                      Assign Cases
                    </button>
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => {
                        setShowCasesModal(false);
                        setSelectedRows([]);
                      }}
                    >
                      <i className="ti ti-x me-1"></i>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ManageVerifierCases;
